if (!customElements.get('joker-quantity-choices')) {
  customElements.define('joker-quantity-choices', class extends HTMLElement {
    connectedCallback() {
      this.quantity = this.closest('product-info')?.querySelector('input.quantity__input');
      if (!this.quantity) return;
      this.onClick = event => {
        const button = event.target.closest('[data-quantity]');
        if (!button) return;
        const previous = this.quantity.value;
        this.quantity.value = button.dataset.quantity;
        if (!this.quantity.checkValidity()) {
          this.quantity.value = previous;
          return;
        }
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.onChange = () => {
        this.querySelectorAll('[data-quantity]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.quantity) === Number(this.quantity.value))));
      };
      this.addEventListener('click', this.onClick);
      this.quantity.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function') this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onChange);
      this.onChange();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.quantity?.removeEventListener('change', this.onChange);
      this.unsubscribeQuantity?.();
    }
  });
}
